// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Yanvo","content":"CSoq4","leadVideo":"Nv3ER","VideoIcon_duration":"EkhkP"};